import { render, staticRenderFns } from "./NotenerfassungFrei.vue?vue&type=template&id=0bc5ae70"
import script from "./NotenerfassungFrei.vue?vue&type=script&lang=js"
export * from "./NotenerfassungFrei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports